import { Component, Input, OnInit } from '@angular/core';

import { File } from './file';

@Component({
  selector: 'file',
  template: `
  <div class="file-field">
    <div class="btn btn-primary btn-sm">
      <span>{{caption}}</span>
      <input type="file" [attr.multiple]="multiple ? true : null" value="test.jp" (change)="onChange($event.target.files)">
    </div>
    <div class="file-path-wrapper">
      <input class="file-path validate" type="text" placeholder="{{placeholder}}">
    </div>
  </div>
  <div class="table-responsive" *ngIf="files.length > 0">
    <table class="table table-bordered table-hover table-striped">
      <thead>
        <tr>
          <th>Name</th>
          <th>Extension</th>
          <th>Type</th>
          <th>Size</th>
          <th>Preview</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let file of files">
          <td>
            <a href="{{file.path}}" target="_blank">{{file.name}}</a>
          </td>
          <td>
            <a href="{{file.path}}" target="_blank">{{file.extension}}</a>
          </td>
          <td>
            <a href="{{file.path}}" target="_blank">{{file.type}}</a>
          </td>
          <td align="right">
            <a href="{{file.path}}" target="_blank">{{file.size / 1000000}} Mo</a>
          </td>
          <td align="center">
            <img src='{{file.img}}' alt="No preview" style="width:64px;height:64px;" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>`
})

export class FileComponent implements OnInit {
  @Input() public name: string = '';
  @Input() public placeholder: string = '';
  @Input() public caption: string = '';
  @Input() public enabled: Boolean = false;
  @Input() multiple: boolean = false;
  public loading: boolean = false;
  public files: File[] = new Array<File>();

  constructor() {
  }

  ngOnInit(): void {
    this.loading = false;
  }

  onChange(files: FileList): void {
    this.loading = true;
    for (let i = 0; i < files.length; i++){
      if (files.item(i).type.indexOf('image/') > -1) {
        const reader = new FileReader();
        const img = document.createElement('img');
        img.src = window.URL.createObjectURL(files.item(i));
        reader.onload = (function(files, filesInput) {
          return function(e: any) {
            const file: File = new File();
            file.setName(filesInput.name);
            file.setSize(filesInput.size);
            file.setType(filesInput.type);
            file.setPath('');
            img.src = e.target.result;
            //file.img = this.resize(img);
            file.img = img.src;
            files.push(file);
          };
        })(this.files, files.item(i));
        reader.readAsDataURL(files.item(i));
      } else {
        const file: File = new File();
        file.setName(files.item(i).name);
        file.setSize(files.item(i).size);
        file.setType(files.item(i).type);
        file.setPath('');
        file.img = '';
        this.files.push(file);
      }
    }
    this.loading = false;
  }

  onDblClick(file: File) {
    if (file) {
      if (file.getPath()) {

      }
    }
  }

  /*setFiles(files: FileList): void {
    this.files = files;
  }

  getFiles(): FileList {
    return this.files;
  }*/

    resize(img: any, MAX_WIDTH: number = 48, MAX_HEIGHT: number = 48) {
        const canvas = document.createElement('canvas');
        console.log('Size Before: ' + img.src.length + ' bytes');

        let width = img.width;
        let height = img.height;

        if (width > height) {
            if (width > MAX_WIDTH) {
                height *= MAX_WIDTH / width;
                width = MAX_WIDTH;
            }
        } else {
            if (height > MAX_HEIGHT) {
                width *= MAX_HEIGHT / height;
                height = MAX_HEIGHT;
            }
        }
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        if (ctx) ctx.drawImage(img, 0, 0, width, height);
        const dataUrl = canvas.toDataURL('image/jpeg');
        console.log('Size After:  ' + dataUrl.length  + ' bytes');
        return dataUrl;
    }
}
